import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1.5" }
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["src", "alt"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
      return _withDirectives((_openBlock(), _createElementBlock("li", {
        key: menu.name
      }, [
        (menu.handle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              role: "button",
              class: "cursor-pointer hover:underline",
              title: menu.name,
              onClick: menu.handle
            }, [
              _createElementVNode("img", {
                src: menu.image,
                alt: menu.name,
                class: "rounded-lg"
              }, null, 8 /* PROPS */, _hoisted_3)
            ], 8 /* PROPS */, _hoisted_2))
          : (menu.href)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: menu.href,
                class: "hover:underline",
                title: menu.name
              }, [
                _createElementVNode("img", {
                  src: menu.image,
                  alt: menu.name,
                  class: "rounded-lg"
                }, null, 8 /* PROPS */, _hoisted_5)
              ], 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
      ])), [
        [_vShow, menu.show]
      ])
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}